// @ts-nocheck
/* eslint-disable */

import * as tocbot from 'tocbot';
import { handleTOCMobile } from './in-page-navigation';

function handleFundTabs() {
  const fundTabItems = document.querySelectorAll('.funds-details-page .fund-tabs .fund-tabs-item');

  const tabsContentItems = document.querySelectorAll('.funds-details-page .tabs-content');

  if (!fundTabItems.length > 0 && !tabsContentItems.length > 0) return;

  fundTabItems.forEach((tabItem) => {
    tabItem.addEventListener('click', () => {
      const id = tabItem.getAttribute('id');

      for (let i = 0; i < fundTabItems.length; i += 1) {
        fundTabItems[Number(i)].classList.remove('active');
      }

      tabItem.classList.add('active');

      tabsContentItems.forEach((item) => {
        const itemHeadings = item.querySelectorAll('h2[id]');
        if (item.getAttribute('data-tab-id') === id || item.getAttribute('data-tab-id') === 'both') {
          item.style.display = 'block';
          item.style.visibility = 'visible';
          if (itemHeadings.length > 0) {
            itemHeadings.forEach((itemHeading) => {
              itemHeading.classList.remove('js-toc-ignore');
            });
          }
        } else {
          item.style.display = 'none';
          item.style.visibility = 'hidden';
          if (itemHeadings.length > 0) {
            itemHeadings.forEach((itemHeading) => {
              itemHeading.classList.add('js-toc-ignore');
            });
          }
        }
        setTimeout(() => {
          tocbot.refresh({ ...tocbot.options, hasInnerContainers: true });
          handleTOCMobile();
        }, 50);
      });

      window.history.pushState({}, null, window.location.pathname + '?tab=' + id);
    });
  });

  const params = new URL(document.location).searchParams;
  const currentTab = params.get('tab');

  if (!currentTab || currentTab === 'fund-facts') {
    // show fund overview by default
    document.querySelector('.funds-details-page .fund-tabs #fund-facts').click();
  } else if (currentTab === 'fund-story') {
    document.querySelector('.funds-details-page .fund-tabs #fund-story').click();
  }
}

// handle fund select
function handleFundSelect() {
  const arrow = document.querySelector('.funds-details-page .fund-select .select-arrow');
  const fundList = document.querySelector('.funds-details-page .fund-select .fund-listing');

  if (arrow && fundList) {
    arrow.addEventListener('click', () => {
      arrow.classList.toggle('active');
      fundList.classList.toggle('open');
    });
  }
}

function comparisonChartFix() {
  const chartTab = document.querySelector('#comparison-chart-tab');

  if (!chartTab) return;

  chartTab.addEventListener('click', () => {
    // see https://yourir.info/docs/#api.rendering

    yourir?.render('comparison-chart');
  });
}

const closeFundsModel = () => {
  const modal = document.querySelector('.fund-eu-country-alert');
  const closeBtn = document.querySelector('.fund-modal-close-btn');

  if (modal && closeBtn) {
    closeBtn.addEventListener('click', () => {
      modal.style.display = 'none';
    });
  }
};

window.addEventListener('DOMContentLoaded', () => {
  handleFundTabs();
  handleFundSelect();
  comparisonChartFix();
  closeFundsModel();
});
